import SwiperCarousel from '../utils/swiper-carousel';
import PDPVideo from '../utils/pdp-video';

export default (element) => {
  const init = () => {
    const swiperContainer = element.querySelector('.pdp-custom-banner-1-swiper');
    if (swiperContainer) {
      // Prevent double initialization (e.g., in Theme Editor or hot reload)
      if (swiperContainer.dataset.swiperInitialized === 'true' || swiperContainer.classList.contains('swiper-initialized')) {
        return null;
      }

      const slides = swiperContainer.querySelectorAll('.swiper-slide');
      const slideCount = slides.length;

      const nextButton = swiperContainer.querySelector('.swiper-button-next');
      const prevButton = swiperContainer.querySelector('.swiper-button-prev');
      
      // Completely simplified approach - disable navigation and handle manually
      const instance = new SwiperCarousel(swiperContainer, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        allowTouchMove: slideCount > 1,
        navigation: false, // Disable automatic navigation
        mousewheel: false,
        scrollbar: false,
        loop: false,
        watchOverflow: true,
      });

      // Handle navigation manually and manage button states
      if (slideCount > 1 && nextButton && prevButton) {
        const updateButtonStates = (swiper) => {
          if (swiper.isBeginning) {
            prevButton.classList.add('swiper-button-disabled');
            prevButton.setAttribute('disabled', 'true');
          } else {
            prevButton.classList.remove('swiper-button-disabled');
            prevButton.removeAttribute('disabled');
          }

          if (swiper.isEnd) {
            nextButton.classList.add('swiper-button-disabled');
            nextButton.setAttribute('disabled', 'true');
          } else {
            nextButton.classList.remove('swiper-button-disabled');
            nextButton.removeAttribute('disabled');
          }
        };

        // Set initial button states
        updateButtonStates(instance.swiper);

        nextButton.addEventListener('click', (e) => {
          e.preventDefault();
          if (instance && instance.swiper && !nextButton.disabled) {
            instance.swiper.slideNext();
            updateButtonStates(instance.swiper);
          }
        });

        prevButton.addEventListener('click', (e) => {
          e.preventDefault();
          if (instance && instance.swiper && !prevButton.disabled) {
            instance.swiper.slidePrev();
            updateButtonStates(instance.swiper);
          }
        });

        // Update button states on slide change (for touch/swipe navigation)
        instance.swiper.on('slideChange', () => {
          updateButtonStates(instance.swiper);
        });
      }

      swiperContainer.dataset.swiperInitialized = 'true';
      return instance;
    }
    return null;
  };

  const initVideos = () => {
    const videoComponents = element.querySelectorAll('[data-component="video"]');
    const videoInstances = [];
    videoComponents.forEach((videoEl) => {
      const videoInstance = new PDPVideo({ element, video: videoEl });
      videoInstances.push(videoInstance);
    });
    return videoInstances;
  };

  const ctaModal = () => {
    const ctaButton = element.querySelector('.accordion-modal-button');
    const modal = element.querySelector('#modal-custom-banner-1');
    const modalOverlay = element.querySelector('.accordion-modal-overlay');

    let handleEscapeKey;
    let handleOverlayClick;

    if (ctaButton) {
      ctaButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (modalOverlay) {
          modalOverlay.classList.toggle('hidden');
          if (modalOverlay.classList.contains('hidden')) {
            modal?.setAttribute('aria-hidden', 'true');
            removeEventListeners();
          } else {
            modal?.setAttribute('aria-hidden', 'false');
            // Event handler for the Escape key
            handleEscapeKey = (event) => {
              if (event.key === 'Escape') {
                removeModal();
              }
            };

            // Event handler for the modal overlay click
            handleOverlayClick = () => {
              removeModal();
            };

            // Add click event listener to the modal overlay
            modalOverlay.addEventListener('click', handleOverlayClick);

            // Existing close button event listener
            const closeButton = modal?.querySelector('button');
            if (closeButton) {
              closeButton.onclick = removeModal;
            }

            // Add event listener for the Escape key
            document.addEventListener('keydown', handleEscapeKey);

            // Prevent scrolling when modal is open
            document.body.style.overflow = 'hidden';
          }
        }
      });
    }

    // Function to remove the modal
    const removeModal = () => {
      modalOverlay.classList.add('hidden');
      modal?.setAttribute('aria-hidden', 'true');
      removeEventListeners();
      // Restore scrolling when modal is closed
      document.body.style.overflow = '';
    };

    // Function to remove event listeners
    const removeEventListeners = () => {
      if (handleEscapeKey) {
        document.removeEventListener('keydown', handleEscapeKey);
      }
      if (handleOverlayClick) {
        modalOverlay.removeEventListener('click', handleOverlayClick);
      }
      const closeButton = modal?.querySelector('button');
      if (closeButton) {
        closeButton.onclick = null;
      }
    };
  };

  ctaModal(element);
  init();
  initVideos();
};
